import { render } from "./LeaveAgePopover.vue?vue&type=template&id=3202a304"
import script from "./LeaveAgePopover.vue?vue&type=script&lang=js"
export * from "./LeaveAgePopover.vue?vue&type=script&lang=js"

import "./LeaveAgePopover.vue?vue&type=style&index=0&id=3202a304&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__